import Vue from "vue";
export default {
  addLocation(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/attendance/mobile-clocks/settings/locations", payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateLocation(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put("/attendance/mobile-clocks/settings/locations", payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getLocations({ state, commit }) {
    const params = {
      per_page: state.perPageForLocations,
      page: state.currentPageForLocations,
    };
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);
      Vue.$http
        .get("/attendance/mobile-clocks/settings/locations", { params })
        .then(response => {
          commit("tableLoading", false);
          const { results, total } = response.data;
          commit("locations", results);
          commit("totalLocations", total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },
  getLocation(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/attendance/mobile-clocks/settings/locations/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteLocation(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/attendance/mobile-clocks/settings/locations/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  assignEmployeeToApprover(_, { data, id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(
          `/attendance/mobile-clocks/settings/approvers/${id}/assign-employees`,
          data
        )
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  handleSizeChangeForLocations({ commit, dispatch }, perPage) {
    commit("perPageForLocations", perPage);
    dispatch("getLocations");
    commit("currentPageForLocations", 1);
  },
  handleCurrentChangeForLocations({ commit, dispatch }, page) {
    commit("currentPageForLocations", page);
    dispatch("getLocations");
  },
  getLogs({ state, commit }) {
    const params = {
      per_page: state.perPageForLogs,
      page: state.currentPageForLogs,
      ...(state.searchQuery && { search_query: state.searchQuery }),
      ...(state.filterDate && { date: state.filterDate }),
      ...(state.filterStatus && { status: state.filterStatus }),
    };
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);
      Vue.$http
        .get("/attendance/mobile-clocks/", { params })
        .then(response => {
          commit("tableLoading", false);
          const { results, total } = response.data;
          commit("logs", results);
          commit("totalLogs", total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },
  handleSizeChangeForLogs({ commit, dispatch }, perPage) {
    commit("perPageForLogs", perPage);
    commit("currentPageForLogs", 1);
    dispatch("getLogs");
  },
  handleCurrentChangeForLogs({ commit, dispatch }, page) {
    commit("currentPageForLogs", page);
    dispatch("getLogs");
  },
};
